export default __webpack_public_path__ + "static/media/saysYes.f76da49c.jpg";